__webpack_require__.p = "//s3-fra01-eu.mykeeta.net/static-prod01/ws-assets/com.keetapp.sailorfe.b.pc/GzL7MQDZKysamSVUvH7Ew/main/";